<div class="fuel-level-map">
  <app-common-map [mapHeight]="'100%'" [isCollapsed]="isCollapsed" [showDropdown]="false" [data]="fuelLevels()"
    [routeLink]="routeLink" [clusterRenderer]="clusterRenderer" [markerFactory]="markerFactory"
    [mapInfoWindowBuilder]="mapInfoWindowBuilder" [mapCenter]="mapCenter" [isLoading]="isLoading()">
  </app-common-map>
</div>